import React from 'react';
import { format, getDay, setDay, addDays } from 'date-fns';
import { useState } from 'react';
import FileSaver from 'file-saver';
import FieldTable from '../../components/field-table';
import { Site, useSiteHsReportMutation, useSiteMainExportReportMutation, useSiteRevenueReportMutation, useSiteStatusReportMutation } from "../../generated/graphql";
import { Button } from "@mui/material";
import { Close, Download } from "@mui/icons-material";
import { IsoDatePicker } from "../../components/IsoDatePicker";
import { ModalWindow } from "../../components/ModalWindow";
import { useToast } from "../../contexts/toast";

let today = new Date();
today = getDay(today) < 1 ? setDay(today, -5, { weekStartsOn: 1 }) : setDay(today, 1, { weekStartsOn: 1 })
const mondayString = format(today, 'yyyy-MM-dd');
const sundayString = format(addDays(today, 6), 'yyyy-MM-dd');

const columns = [
    {
        accessor: 'data.id',
        noSort: true,
        dataType: 'selector'
    }, {
        accessor: 'name',
        header: 'Site Name',
        dataType: 'default'
        // eslint-disable-next-line react/display-name
    }, {
        accessor: 'region.name',
        header: 'Region',
        dataType: 'default'
    }];

type RevenueReportModalArgs = {
    isOpen: boolean,
    values: Site[],
    doClose: () => void
}


const MainExportReport = (props: RevenueReportModalArgs) => {
    const [dateFromValue, setDateFromValue] = useState(mondayString);
    const [dateToValue, setDateToValue] = useState(sundayString);
    const [isWait, setWait] = useState(false);
    const [mutation] = useSiteMainExportReportMutation({ fetchPolicy: 'no-cache' });
    const { toast, dismiss } = useToast();
    const [selectedRows, setSelectedRows] = useState({});

    async function submitForm() {
        if (isWait) return;
        if (!dateFromValue || !dateToValue) return;
        const selectedIds = [];

        Object.entries(selectedRows).forEach(function ([name, value]) {
            if (value) {
                selectedIds.push(name);
            }
        });
        if (!selectedIds.length) {
            toast('Please select sites before generating report', { variant: 'error' });
            return;
        }
        const genId = toast('Generating report', { variant: 'info', timeout: 0 });
        setWait(true);
        try {
            const data = await mutation({
                variables: {
                    selectedIds: selectedIds
                }
            });
            setWait(false);

            dismiss(genId);
            toast('Rendering file', { variant: 'info' });
            const res = await fetch(data?.data?.siteMainExportReport?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent, 'site-main-export-report-' + dateFromValue + '__' + dateToValue + '.xlsx');
            //window.open(blobUrl);
        } catch (e) {
            dismiss(genId);
            toast(e && e.graphqlErrors && e.graphqlErrors.length ? e.graphqlErrors[0].debugMessage : 'Download failed', { variant: 'error' });
            setWait(false);
        }
    }
    let content = null, actions = null;
    if (props.isOpen) {
        actions = <>
            <Button color="primary" onClick={props.doClose} startIcon={<Close />}>Close</Button>
            <Button color="primary" onClick={submitForm} startIcon={<Download />}>Generate Report</Button>
        </>;
        content = (
            <>
                <h4>Sites</h4>
                <FieldTable setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows} hasDelete={false} values={props.values}
                    columns={columns} hasExport={false} />
            </>);
    }
    return <ModalWindow isOpen={props.isOpen} onClose={props.doClose} header={"Main Export Report"} actions={actions} maxWidth="md">
        {content}
    </ModalWindow>;
}

export default MainExportReport;

